import { jsx as _jsx, jsxs as _jsxs } from "@emotion/react/jsx-runtime";
import { propFunc, propStr } from '../../../helpers/custom-prop-types';
import { compose } from '../../../helpers/recompose';
import ModalHoc from './ModalHoc';
/**
 * @param props
 * @returns {JSX.Element}
 * @constructor
 */
const OtherProfessionalAlertModal = (props) => {
    const { hideModal, modalState } = props;
    return (_jsxs("div", Object.assign({ className: `fade_modal alert_modal ${modalState}` }, { children: [_jsx("div", { className: 'bg', onClick: hideModal, role: 'presentation' }), _jsx("div", Object.assign({ className: 'modal_body' }, { children: "\u4ED6\u793E\u306E\u30B3\u30F3\u30B5\u30EB\u30BF\u30F3\u30C8\u306E\u65B9\u306E\u60C5\u5831\u306F\u30CE\u30A6\u30CF\u30A6\u3092\u4FDD\u8B77\u3059\u308B\u305F\u3081\u3001\u958B\u793A\u3067\u304D\u307E\u305B\u3093\u3002" }))] })));
};
OtherProfessionalAlertModal.propTypes = {
    hideModal: propFunc().isRequired,
    modalState: propStr().isRequired,
};
const enhance = compose(ModalHoc);
export default enhance(OtherProfessionalAlertModal);
